// Menu tambahan yang tidak (belum) diatur dari database (Administrasi -> Menu).
// Master Data -> Petani (read only) untuk role selain admin.
//
// Catatan: Sidebar (react-web-skeleton) membuat link child sebagai
// `parent.url + child.url`, jadi url child relatif terhadap parent-nya
// (mis. parent "/master-data/purchasing" + child "/wilayah").
const ROLES_WITH_MASTER_PETANI = ['purchasing', 'finance', 'cfo'];

const withLeadingSlash = (url = '') => (url ? url.replace(/^\/?/, '/') : '');

// url lengkap yang benar-benar dibuka sidebar
const allUrls = (menus) =>
  menus.flatMap((menu) => [
    withLeadingSlash(menu?.url),
    ...(menu?.childs || []).map(
      (child) => `${withLeadingSlash(menu?.url)}${withLeadingSlash(child?.url)}`
    ),
  ]);

// role aktif dikenali dari url menu yang dimiliki, mis. /dashboard/purchasing
const getRoleKey = (urls) =>
  ROLES_WITH_MASTER_PETANI.find((role) =>
    urls.some((url) => url.split('/').includes(role))
  );

export const withExtraMenus = (sidebarMenu) => {
  if (!Array.isArray(sidebarMenu)) return sidebarMenu;

  const urls = allUrls(sidebarMenu);
  const roleKey = getRoleKey(urls);
  if (!roleKey) return sidebarMenu;

  const masterDataUrl = `/master-data/${roleKey}`;
  const petaniUrl = `${masterDataUrl}/petani`;
  // sudah ditambahkan admin lewat database
  if (urls.includes(petaniUrl)) return sidebarMenu;

  const masterDataIndex = sidebarMenu.findIndex(
    (menu) =>
      menu?.name?.toLowerCase() === 'master data' ||
      withLeadingSlash(menu?.url).startsWith('/master-data')
  );

  if (masterDataIndex >= 0) {
    const parentUrl = withLeadingSlash(sidebarMenu[masterDataIndex].url);
    // url child relatif terhadap url parent yang ada di database
    const childUrl = petaniUrl.startsWith(`${parentUrl}/`)
      ? petaniUrl.slice(parentUrl.length)
      : petaniUrl;
    return sidebarMenu.map((menu, index) =>
      index === masterDataIndex
        ? {
            ...menu,
            childs: [...(menu.childs || []), { name: 'Petani', url: childUrl }],
          }
        : menu
    );
  }

  // role belum punya grup Master Data (mis. Finance / CFO): buat grup baru setelah Dashboard
  const masterDataMenu = {
    name: 'Master Data',
    url: masterDataUrl,
    icon: '',
    childs: [{ name: 'Petani', url: '/petani' }],
  };
  return [sidebarMenu[0], masterDataMenu, ...sidebarMenu.slice(1)].filter(
    Boolean
  );
};
